import styled from 'styled-components';
import { Typ41, Typ35 } from 'dc/Typ';
import Btn021 from 'dc/Btn021';

export const Container = styled.div`
  width: 458px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  margin-top: 50px;
  padding: 56px 86px 68px 86px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Image = styled.img`
  width: 175px;
  height: 175px;
  margin-bottom: 32px;
`;

export const Title = styled(Typ41)`
  margin-bottom: 12px;
`;

export const Text = styled(Typ35)`
  line-height: 19px;
  margin-bottom: 76px;
  text-align: center;
  color: #263238;
`;

export const ContinueButton = styled(Btn021)`
  width: 100%;
  height: 40px;
`;
